export default __webpack_public_path__ + "img/02de1012d650e5d3ccb81fbcdecbf25f.jpg";